var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content" }, [
    _c(
      "div",
      { staticStyle: { "margin-bottom": "10px", "text-align": "left" } },
      [
        _c(
          "el-button",
          { attrs: { no: "onAdd", type: "primary" }, on: { click: _vm.onAdd } },
          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
        ),
        _c(
          "el-button",
          {
            attrs: {
              no: "onDel",
              type: "danger",
              disabled: _vm.selectLength === 0
            },
            on: { click: _vm.onDel }
          },
          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "section grid-wrapper" },
      [
        _c("cargo-ag-grid", {
          attrs: {
            "config-module": _vm.configModule,
            "grid-options": _vm.gridOptions,
            "column-defs": _vm.columnDefs,
            "row-data": _vm.rowData
          }
        })
      ],
      1
    ),
    _c(
      "div",
      {
        staticStyle: { "text-align": "right" },
        attrs: { slot: "footer" },
        slot: "footer"
      },
      [
        _c(
          "el-button",
          {
            attrs: { no: "37", type: "primary" },
            on: { click: _vm.onConfirm }
          },
          [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
        ),
        _c("el-button", { attrs: { no: "38" }, on: { click: _vm.onCancel } }, [
          _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }